import { stringToHslColor } from '../utils/color';
import Goal from '../goals/class';
import Project from '../projects/class';

const apiBaseURL = process.env.REACT_APP_API_URL;

class User {
  constructor(data) {
    this._id = data._id;
    this.workspace = data.workspace;

    this.name = data.name;
    this.email = data.email;
    this.avatarUrl = data.avatarUrl;
    // If langauge is not set, default to BG,
    // because accounts which don't have any lang set are probably the first one,
    // which were our internal accounts at DevLabs
    this.lang = data.lang || 'bg';

    this.urls = data.urls;
    this.roles = data.roles;

    this.projects = data.projects.map((p) => ({
      ...p,
      project:
        // When project is a string, it is not normalized, coming as a string ID.
        // In the other case, the API returns normalized, filled-in object.
        typeof p.project === 'string' ? p.project : new Project(p.project),
    }));

    this.goals = data.goals && data.goals.map((g) => new Goal(g));

    this.upToDateConfirmedAt = data.upToDateConfirmedAt;
  }

  getBigAvatarUrl = () =>
    this.avatarUrl
      ? `${apiBaseURL}avatars/thumb-500x500-${this.avatarUrl}`
      : `https://dummyimage.com/500x500/${stringToHslColor(
          this.name
        )}/ffffff.jpg&text=${this.name.slice(0, 1).toUpperCase()}`;
  getSmallAvatarUrl = () =>
    this.avatarUrl
      ? `${apiBaseURL}avatars/thumb-165x165-${this.avatarUrl}`
      : `https://dummyimage.com/165x165/${stringToHslColor(
          this.name
        )}/ffffff.jpg&text=${this.name.slice(0, 1).toUpperCase()}`;
}

export default User;



// WEBPACK FOOTER //
// ./src/user/class.js